import { getData } from "@/utils/http";
import config from "@/config"
export default {
    namespaced: true,
    state: {
        tableLoading: true,
        addLoading: false,
        activeItem: null,
        tableList: [],
        total: 0,
        pageIndex: 1,

        //查询参数
        deptId: "",
        name: "",
        carNo: "",
        status: ""
    },
    mutations: {
        CHANGE_TABLE_LOADING(state, tableLoading) {
            state.tableLoading = tableLoading
        },
        CHANGE_ADD_LOADING(state, addLoading) {
            state.addLoading = addLoading
        },
        CHANGE_TABLE_DATA(state, changeData) {
            changeData.data.rows.forEach(ds => {
                ds.transTime = ds.transTime.split(' ')[0];
            })
            state.tableList = changeData.data.rows
            state.total = changeData.total
        },
        CHANGE_ACTIVE_ITEM(state, item) {
            state.activeItem = item
        },
        CHANG_CHILD_ACTIVE_ITEM(state, item) {
            state.childActiveItem = item
        },
        CHANGE_SEARCH_COLL(state, changeData) {
            if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
                state[changeData['changeKey']] = [changeData['data']]
            } else {
                state[changeData['changeKey']] = changeData['data']
            }
        },
        CHANGE_TABLE_INDEX(state, value) {
            state.pageIndex = value
        }
    },
    actions: {
        //获取客户列表
        getList({ commit, state }, deptId) {
            const queryParams = config.jsonToQueryParams({
                page: state.pageIndex,
                size: config.pageSize,
                status: state.status,
                name: state.name,
                deptId: deptId,
                carNo: state.carNo
            })
            return new Promise(resolve => {
                getData(`logistics/temp/waybill/page?${queryParams}`).then(res => {
                    if (res.state == 1) {
                        commit('CHANGE_TABLE_DATA', res)
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },

        //写入当前操作条目
        setActiveItem({ commit }, item) {

            const options = [{ text: 'T(吨)', value: 1 }, { text: '车', value: 2 }, { text: '方', value: 3 }, { text: '件', value: 4 }];
            options.forEach(ds => {
                if (item.transportUnit == ds.value) {
                    item.transportUnit = ds.text
                }
            });
            commit('CHANGE_ACTIVE_ITEM', item)
        },

        //写入查询条件
        setSearchData({ commit }, changeData) {
            commit('CHANGE_SEARCH_COLL', changeData)
        },
        //修改分页
        setPageIndex({ commit }, value) {
            commit('CHANGE_TABLE_INDEX', value)
        },
        //修改添加loading
        changeAddLoading({ commit }, value) {
            commit('CHANGE_ADD_LOADING', value)
        },
        //修改添加loading
        changeListLoading({ commit }, value) {
            commit('CHANGE_TABLE_LOADING', value)
        }
    }
}